import {
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { ControlPoint, LockOpenSharp, LockSharp } from "@material-ui/icons";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import CachedIcon from "@material-ui/icons/Cached";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CropRotateIcon from "@material-ui/icons/CropRotate";
import HistoryIcon from "@material-ui/icons/History";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import LoupeIcon from "@material-ui/icons/Loupe";
import MoreIcon from "@material-ui/icons/More";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import { ENABLE_HISTORY } from "app/appConfig";
import TableComponent from "app/common/Component/Table/TableComponent";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import IconMedicalHistory from "app/common/Icon/EyeTestTabs/IconMedicalHistory";
import IconDelete from "app/common/Icon/IconDelete";
import IconPen from "app/common/Icon/IconPen";
import {
  ACTIVE_STATUS,
  LIST_DATE_UNIT,
  LOCKED_STATUS,
} from "app/common/LocalConst";
import {
  checkPaymentMethodLimits,
  formatMoney,
  formatNumber,
  getDate,
  getDateTime,
  isAdmin,
  isRoleBranchManager,
  isRoleCashier,
  isRoleHisAccountant,
  isRoleHisReadOnly,
  isRoleManualExchange,
  isSalesConsultant,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
const ListAllServices = () => {
  const { t } = useTranslation();
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const {
    handleChangeFormSearchService,
    searchAllServices,
    pageAllServices,
    handleOpenChangeServicePopup,
    handleOpenCreateOrEditServicePopup,
    handleOpenConfirmUnlock,
    handleOpenConfirmDelete,
    setSelectRegisterServiceId,
    handleOpenRegisterServiceHistoryPopup,
    handleOpenConfirmlock,
    handleOpenHistoryServicePopup,
    handleOpenUpdateTotalTreatmentPopup,
    handleOpenGetTreatmentTimesEachServicesConfirm,
    handleOpenHistoryTreamentServicePopup,
    handleOpenFormMainServiceRegister,
    handleOpenWarrantyServicePopup,
  } = useStore().patientManagementStore.allServicesTabStore;

  const {
    handleOpenPaymentVoucherPopup,
    handleOpenTotalBillStatusInvoiceItemConfirm,
    handleOpenFormLockRetaind,
  } = useStore().feeStore.serviceFeeTabStore;

  const {
    initialPatient,
    customerSourceWalkIn,
    handleOpenHistoryStaffRevenuePopup,
  } = useStore().patientManagementStore.patientGeneralStore;

  const { handleOpenPopupHistoryChangeRemain } =
    useStore().feeStore.historyChangeRemainTabStore;
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleMenuOpen = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(rowData);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };
  let isAdminPermission = isAdmin();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const isReadonly = isRoleHisReadOnly();
  const location = useLocation();
  const isAdminRole = isAdmin();
  const isBranchManager = isRoleBranchManager();
  const isCashier = isRoleCashier();
  const isRoleSalesConsultant = isSalesConsultant();
  const isHisAccountant = isRoleHisAccountant();

  const canUpdateMainServiceRegister =
    isAdminRole || isBranchManager || isRoleSalesConsultant || isCashier;

  const isInDetailPage =
    location.pathname === "/treatment-management/treatment-patient-info-detail";
  const isEdit =
    ((isAdminRole || isBranchManager || isCashier || isHisAccountant) &&
      !isInDetailPage) ||
    (isInDetailPage && isAdminRole);
  const defaultDepartment = useDefaultDepartment();
  const isManualExchange = isRoleManualExchange();
  const canManualExchange = isAdminRole || isManualExchange;

  return (
    <Grid
      container
      spacing={1}
      className="justify-center cards-body pt-0 mt-2"
      style={{
        zIndex: 1,
        position: "relative",
      }}
    >
      <Grid item xs={12}>
        <TableComponent
          showOrdinalNumbers
          titleNodata={t("noData")}
          data={pageAllServices?.content || []}
          minWidth={"720px"}
          maxHeight={"460px"}
          name="ListRegisterServiceAll"
          showMoreButton
          columns={[
            ...(!isInDetailPage
              ? [
                {
                  title: t("Tạo phiếu chi"),
                  field: "action",
                  width: "70px",
                  render: (row) => {
                    return (
                      <div className="flex-center gap-2">
                        {!isReadonly && (
                          <>
                            <Tooltip title={"Tạo phiếu chi"}>
                              <div
                                onClick={() => {
                                  let staffRevenues = row?.staffRevenues?.map(
                                    (el) => ({ ...el, id: null })
                                  );
                                  handleOpenPaymentVoucherPopup(
                                    initialPatient?.patientInfo,
                                    null,
                                    customerSourceWalkIn,
                                    {
                                      patientServiceRegister: row,
                                      totalAmount:
                                        row?.totalBillPatientPaid || 0,
                                      staffRevenues: staffRevenues,
                                    }
                                  );
                                }}
                                className="mr-1 flex"
                              >
                                <ControlPoint
                                  style={{
                                    color: "#3f51b5",
                                    fontSize: "22px",
                                  }}
                                />
                              </div>
                            </Tooltip>
                          </>
                        )}
                      </div>
                    );
                  },
                },
              ]
              : []),
            {
              field: "service.tradeName",
              title: t("Thao tác"),
              align: "center",
              render: (row) => {
                const isLocked = row?.activeStatus === LOCKED_STATUS;
                const canShowChangeService =
                  isEdit && !isLocked && canManualExchange;
                return (
                  <>
                    <div className="flex-center gap-2 cursor">
                      {isEdit && (
                        <Tooltip title={"Xem chi tiết"}>
                          <div
                            onClick={() =>
                              handleOpenCreateOrEditServicePopup({
                                ...row,
                                isDisabled: true,
                              },
                                initialPatient?.patientInfo,
                                defaultDepartment
                              )
                            }
                            className="ml-1 flex"
                          >
                            <IconPen />
                          </div>
                        </Tooltip>
                      )}

                      {!isLocked &&
                        isEdit &&
                        ((isInDetailPage && isAdminRole) ||
                          !isInDetailPage) && (
                          <Tooltip title="Xóa">
                            <div
                              className="flex ml-1"
                              onClick={() => handleOpenConfirmDelete(row?.id)}
                            >
                              <IconDelete />
                            </div>
                          </Tooltip>
                        )}

                      <Tooltip title="Tùy chọn">
                        <IconButton
                          size="small"
                          onClick={(e) => handleMenuOpen(e, row)}
                        >
                          <MoreVertIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                    <Menu
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl) && selectedRow?.id === row?.id}
                      onClose={handleMenuClose}
                      PaperProps={{
                        style: {
                          boxShadow: "none",
                        },
                      }}
                    >
                      {isEdit && (
                        <>
                          {!isLocked && (
                            <MenuItem
                              onClick={() => {
                                handleOpenConfirmlock(row?.id);
                                handleMenuClose();
                              }}
                            >
                              <Tooltip title={"Khóa"}>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    alignItems: "center",
                                  }}
                                >
                                  <LockSharp
                                    style={{
                                      color: "#3f51b5",
                                      fontSize: "22px",
                                    }}
                                  />
                                  <span>Khóa</span>
                                </div>
                              </Tooltip>
                            </MenuItem>
                          )}

                          {!isLocked && (
                            <MenuItem
                              onClick={() => {
                                handleOpenFormLockRetaind(row);
                                handleMenuClose();
                              }}
                            >
                              <Tooltip title={"Khóa và lưu trữ số dư"}>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    alignItems: "center",
                                  }}
                                >
                                  <LockSharp
                                    style={{
                                      color: "#3f51b5",
                                      fontSize: "22px",
                                    }}
                                  />
                                  <span>Khóa và lưu trữ số dư</span>
                                </div>
                              </Tooltip>
                            </MenuItem>
                          )}
                          {isLocked && (
                            <MenuItem
                              onClick={() => {
                                handleOpenConfirmUnlock(row?.id);
                                handleMenuClose();
                              }}
                            >
                              <Tooltip title={"Mở khóa"}>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    alignItems: "center",
                                  }}
                                >
                                  <LockOpenSharp
                                    style={{
                                      color: "#3f51b5",
                                      fontSize: "22px",
                                    }}
                                  />
                                  <span>Mở khóa</span>
                                </div>
                              </Tooltip>
                            </MenuItem>
                          )}
                        </>
                      )}

                      {!isLocked && ENABLE_HISTORY && (
                        <MenuItem
                          onClick={() => {
                            setSelectRegisterServiceId(row?.id);
                            handleOpenRegisterServiceHistoryPopup();
                            handleMenuClose();
                          }}
                        >
                          <Tooltip title="Lịch sử">
                            <div className="flex">
                              <HistoryIcon />
                              <span>Lịch sử</span>
                            </div>
                          </Tooltip>
                        </MenuItem>
                      )}

                      {canShowChangeService && (
                        <MenuItem
                          onClick={() => {
                            if (!isLocked) {
                              handleOpenChangeServicePopup(row);
                              handleMenuClose();
                            }
                          }}
                        >
                          <Tooltip
                            title={`${isLocked ? "Dịch vụ đã khóa" : "Đổi dịch vụ"
                              } `}
                          >
                            <div
                              style={{
                                cursor: isLocked ? "not-allowed" : "pointer",
                                opacity: isLocked ? 0.5 : 1,
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                              }}
                            >
                              <SyncAltIcon color="primary" />
                              <span>Đổi dịch vụ</span>
                            </div>
                          </Tooltip>
                        </MenuItem>
                      )}
                      {isAdminPermission && (
                        <MenuItem
                          onClick={() => {
                            handleOpenUpdateTotalTreatmentPopup({
                              pasId: row?.id,
                            });
                            handleMenuClose();
                          }}
                        >
                          <Tooltip title={"Tính lại tổng số lần điều trị"}>
                            <div className="flex gap-1 align-center">
                              <CachedIcon color="primary" />
                              <span>Tính lại tổng số lần điều trị</span>
                            </div>
                          </Tooltip>
                        </MenuItem>
                      )}

                      {isAdminPermission && row?.currentInvoiceItemId && (
                        <MenuItem
                          onClick={() => {
                            handleOpenTotalBillStatusInvoiceItemConfirm(
                              row?.currentInvoiceItemId
                            );
                            handleMenuClose();
                          }}
                        >
                          <Tooltip
                            title={
                              "Tính số tiền và cập nhật trạng thái thanh toán "
                            }
                          >
                            <div className="flex gap-1 align-center">
                              <CropRotateIcon color="primary" />
                              <span>
                                Tính số tiền và cập nhật trạng thái thanh toán{" "}
                              </span>
                            </div>
                          </Tooltip>
                        </MenuItem>
                      )}

                      {isAdminPermission && (
                        <MenuItem
                          onClick={() => {
                            handleOpenGetTreatmentTimesEachServicesConfirm(
                              row?.id
                            );
                            handleMenuClose();
                          }}
                        >
                          <Tooltip title={"Tính lại số lần thực hiện"}>
                            <div className="flex gap-1 align-center">
                              <LoupeIcon color="primary" />
                              <span>Tính lại số lần thực hiện</span>
                            </div>
                          </Tooltip>
                        </MenuItem>
                      )}
                      <MenuItem
                        title="Xem những dịch vụ đã điều trị"
                        onClick={() => {
                          handleOpenHistoryTreamentServicePopup(
                            row?.id,
                            initialPatient?.patientInfo?.id
                          );
                          handleMenuClose();
                        }}
                      >
                        <div className="flex gap-1 align-center">
                          <AssignmentTurnedInIcon
                            style={{ marginRight: 8 }}
                            color="primary"
                          />
                        </div>
                        <span>Lịch sử điều trị</span>
                      </MenuItem>
                      <MenuItem>
                        <Tooltip
                          title="Xem phiếu bảo hành"
                          onClick={() => {
                            handleMenuClose();
                            handleOpenWarrantyServicePopup(row);
                          }}
                        >
                          <div className="flex gap-1 align-center">
                            <MoreIcon
                              style={{
                                width: "20px",
                                marginRight: 8,
                                color: "#3f51b5",
                              }}
                            />
                            <span>Xem phiếu bảo hành</span>
                          </div>
                        </Tooltip>
                      </MenuItem>
                      <MenuItem
                        title="Xem lịch sử dịch vụ"
                        onClick={() => {
                          handleOpenHistoryServicePopup({
                            patient: initialPatient?.patientInfo,
                            id: row?.id,
                          });
                          handleMenuClose();
                        }}
                      >
                        <div className="flex gap-1 align-center">
                          <IconMedicalHistory
                            color="blue"
                            style={{ width: "21px", marginRight: 8 }}
                          />
                        </div>
                        <span>Xem lịch sử dịch vụ</span>
                      </MenuItem>

                      <MenuItem>
                        <Tooltip
                          title="Xem lịch sử phân bổ"
                          onClick={() => {
                            handleMenuClose();
                            handleOpenHistoryStaffRevenuePopup({
                              // id:row?.id,
                              patientServiceRegisterId: row?.id,
                            });
                          }}
                        >
                          <div className="flex gap-1 align-center">
                            <IconMedicalHistory
                              style={{ width: "21px", marginRight: 8 }}
                              color="blue"
                            />
                            <span>Xem lịch sử phân bổ</span>
                          </div>
                        </Tooltip>
                      </MenuItem>

                      <MenuItem>
                        <Tooltip
                          title="Xem lịch sử chuyển đổi số dư"
                          onClick={() => {
                            handleMenuClose();
                            handleOpenPopupHistoryChangeRemain({
                              patientId,
                              invoiceItemId: row?.currentInvoiceItemId,
                            });
                          }}
                        >
                          <div className="flex gap-1 align-center">
                            <IconMedicalHistory
                              style={{ width: "21px", marginRight: 8 }}
                              color="blue"
                            />
                            <span>Xem lịch sử phân chuyển đổi số dư</span>
                          </div>
                        </Tooltip>
                      </MenuItem>
                    </Menu>
                  </>
                );
              },
            },
            {
              title: t("Mã đơn hàng"),
              field: "code",
            },
            {
              field: "service.tradeName",
              title: t("Dịch vụ"),
              render: (row) => {
                let percent =
                  (+row?.totalPerformedTimes * 100) /
                  +row?.totalTreatmentTimes || 0;
                return (
                  <div className="pl-1 pr-1">
                    <div>
                      <span className="service-code">{row?.service?.code}</span>{" "}
                      <span className="service-name">
                        {checkPaymentMethodLimits()
                          ? row?.service?.registeredName ||
                          row?.service?.tradeName
                          : row?.service?.tradeName}
                      </span>
                    </div>
                    <div class="fancy-progress-wrapper mt-1">
                      <div class="fancy-progress-text">
                        {row?.totalPerformedTimes} | {row?.totalTreatmentTimes}
                      </div>
                      <div class="fancy-progress-bar">
                        <div
                          class="fancy-progress-fill"
                          style={{ width: `${percent}%` }}
                        ></div>
                      </div>
                    </div>
                    <div className="flex mt-2">
                      <div>
                        Đã thu:{" "}
                        <b style={{ color: "green" }}>
                          {formatMoney(row?.totalBillPatientPaid || 0)}
                        </b>
                      </div>
                      <span className="mx-2 text-gray-400">|</span>
                      <div>
                        Cần thu:{" "}
                        <b style={{ color: "red" }}>
                          {formatMoney(row?.amountActuallyPaid)}
                        </b>
                      </div>
                    </div>
                  </div>
                );
              },
            },
            {
              field: "practitioner.staffName",
              title: t("Giá"),
              render: (row) => formatMoney(row?.price),
              align: "right",
              isHide: true,
            },
            {
              field: "quantity",
              title: t("SL đăng ký ban đầu"),
              align: "right",
              isHide: true,
            },
            {
              field: "remainingTreatmentTimes",
              title: t("SL sau đổi"),
              align: "right",
            },
            {
              field: "totalVolumeSold",
              title: t("Số cc bán"),
              align: "right",
            },
            {
              field: "totalVolumeSold",
              title: t("Tổng số cc đã điều trị"),
              align: "right",
              render: (row) => {
                const performed = row?.totalPerformedTimes ?? 0;
                const total = row?.totalTreatmentTimes ?? 0;
                const sold = row?.totalVolumeSold ?? 0;

                const volumeTreated =
                  total > 0 ? (performed / total) * sold : 0;

                return volumeTreated;
              },
            },
            {
              field: "practitioner.staffName",
              title: t("Thành tiền"),
              width: "240px",
              isHide: true,
              render: (data) => {
                return (
                  <div className="total-data-group">
                    <div className="flex justify-between">
                      Thành tiền:{" "}
                      <b>{formatMoney(data?.price * data?.quantity)}</b>
                    </div>
                    <div className="flex justify-between">
                      Giảm giá: <b>{formatMoney(data?.discount)}</b>
                    </div>

                    <div className="flex justify-between">
                      <b
                        className="flex justify-between"
                        style={{ width: "100%" }}
                      >
                        Số tiền (sau giảm):{" "}
                        <b>
                          {formatMoney(
                            data?.price * data?.quantity -
                            (+data?.discount || 0)
                          )}
                        </b>
                      </b>
                    </div>

                    {data?.allocateDiscount ? (
                      <div>
                        <b
                          className="flex justify-between"
                          style={{ width: "100%" }}
                        >
                          Giảm tổng HĐ:{" "}
                          <b>{formatMoney(data?.allocateDiscount)}</b>
                        </b>
                      </div>
                    ) : (
                      <></>
                    )}
                    <div
                      style={{
                        background: "#ccc",
                        width: "100%",
                        height: "1px",
                        margin: "4px 0",
                      }}
                    ></div>
                    <div className="flex justify-between">
                      <b
                        className="flex justify-between"
                        style={{ width: "100%" }}
                      >
                        Tổng thanh toán:{" "}
                        <b>{formatMoney(+data?.amountActuallyPaid || 0)}</b>
                      </b>
                    </div>
                  </div>
                );
              },
            },
            {
              field: "clientCard.name",
              title: t("Ngày đăng ký"),
              render: (val) => getDateTime(val?.orderDate),
            },
            {
              field: "clientCard.name",
              title: t("Liệu trình"),
              render: (val) => val?.treatmentPlanCard?.clientCard?.name,
            },
            {
              field: "clientCard.name",
              title: t("Doanh thu phân bổ(nhân viên)"),
              width: "350px",
              render: (val) => {
                return (
                  <>
                    {val?.staffRevenues?.map((staffRevenue, index) => (
                      <div
                        key={index}
                        className="revenue-item"
                        style={{
                          display: "flex",
                          fontSize: isMobile ? 12 : 14,
                          marginBottom: 6,
                          padding: "4px 0",
                          borderBottom: "1px solid gray",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <span className="revenue-percent">
                            {staffRevenue?.source?.name} -{" "}
                          </span>
                          <span className="position">
                            {" "}
                            {staffRevenue?.position?.name} -{" "}
                          </span>
                        </div>
                        <div>
                          <b className="staff-name">
                            {staffRevenue?.staff?.staffName}
                          </b>
                          <i className="revenue-percent">
                            {staffRevenue?.actualAmount && (
                              <span className="label-primary-number">
                                {formatMoney(staffRevenue?.actualAmount)}
                                {"-"}
                              </span>
                            )}
                            {formatNumber(staffRevenue?.percentRevenue) + "%"}
                          </i>
                        </div>
                      </div>
                    ))}
                  </>
                );
              },
            },

            {
              field: "createdBy",
              title: t("Người tạo"),
              isHide: true,
            },
            {
              field: "modifiedBy",
              title: t("Người sửa"),
              isHide: true,
            },
            {
              field: "department.name",
              title: t("Cơ sở"),
            },
            {
              field: "treatmentStartDate",
              title: t("Ngày bắt đầu điều trị"),
              render: (val) => getDate(val?.treatmentStartDate),
            },
            {
              field: "activeStatus",
              title: t("Trạng thái"),
              render: (row) => (
                <div style={{ textAlign: "center" }}>
                  {row?.activeStatus === ACTIVE_STATUS ? (
                    <Tooltip title="Đang mở">
                      <LockOpenIcon />
                    </Tooltip>
                  ) : row?.activeStatus === LOCKED_STATUS ? (
                    <Tooltip title="Đã khóa">
                      <LockIcon />
                    </Tooltip>
                  ) : (
                    ""
                  )}
                  {row?.cancelAmount != null && (
                    <div className="service-name " style={{ fontSize: "10px" }}>
                      {" "}
                      Số tiền chốt khi hủy:{formatMoney(row?.cancelAmount)}
                    </div>
                  )}
                </div>
              ),
            },
            // {
            //   field: "hasWarranty",
            //   title: t("Bảo hành"),
            //   render: (rowData) => (rowData?.hasWarranty ? "Có" : "Không"),
            // },

            {
              field: "hasWarranty",
              title: t("Bảo hành"),
              render: (rowData) =>
                rowData?.hasWarranty ? (
                  <CheckCircleIcon style={{ color: "green" }} />
                ) : (
                  <CancelIcon style={{ color: "red" }} />
                ),
            },

            {
              field: "warrantyInfo",
              title: t("Thời gian BH"),
              render: (rowData) => {
                if (rowData?.hasWarranty) {
                  const duration = rowData?.warrantyDuration;
                  const unitName =
                    LIST_DATE_UNIT.find(
                      (u) => u.value === rowData?.warrantyUnit
                    )?.name || "";
                  return duration ? `${duration} (${unitName})` : "";
                }
                return "";
              },
            },
            {
              field: "warrantyTotalTimes",
              title: t("Tổng số lần BH"),
              render: (rowData) => {
                if (rowData?.hasWarranty) {
                  return rowData?.warrantyTotalTimes || 0;
                }
                return "";
              },
            },
            {
              field: "warrantyUsedTimes",
              title: t("Tổng số lần đã BH"),
              render: (rowData) => {
                if (rowData?.hasWarranty) {
                  return rowData?.warrantyUsedTimes || 0;
                }
                return "";
              },
            },
            {
              field: "retainedAmount",
              title: t("Số dư lưu trữ"),
              render: (val) => formatMoney(val?.retainedAmount),
            },
            {
              field: "createDate",
              title: t("Ngày tạo hệ thống"),
              render: (val) => getDateTime(val?.createDate),
              isHide: true,
            },
            {
              field: "oldPatientServiceRegister",
              title: t("DV/SP cũ"),
              render: (val) =>
                val?.oldPatientServiceRegister?.name || val?.oldDrugOrder?.name,
            },
            {
              title: t("Mã đơn hàng cũ"),
              field: "codeOld",
              width: "50px",
              render: (val) =>
                val?.oldDrugOrder?.code ||
                val?.oldPatientServiceRegister?.code ||
                val?.treatmentPlanCard?.oldTreatmentPlanCard?.code,
            },
            {
              title: t("Ngày hết hạn BH"),
              field: "codeOld",
              width: "50px",
              render: (val) => getDateTime(val?.warrantyExpiryDate)

            },
            {
              field: "mainService",
              title: t("Đơn hàng bảo hành"),
              render: (row) => {
                const mainService = row?.mainServiceRegister;
                const service = mainService?.service;

                return (
                  <div style={{ padding: "4px 6px" }}>
                    {service?.code && (
                      <div>
                        <strong style={{ color: "#1976d2" }}>
                          {service.code}
                        </strong>{" "}
                        {checkPaymentMethodLimits()
                          ? service?.registeredName || service?.tradeName
                          : service?.tradeName}
                      </div>
                    )}

                    {mainService?.code && (
                      <div style={{ fontSize: 12, color: "#555" }}>
                        Mã đơn hàng: <strong>{mainService.code}</strong>
                      </div>
                    )}

                    {mainService?.orderDate && (
                      <div style={{ fontSize: 12, color: "#555" }}>
                        Ngày đăng ký: {getDateTime(mainService.orderDate)}
                      </div>
                    )}

                    {canUpdateMainServiceRegister && (
                      <Tooltip title="Cập nhật đơn hàng bảo hành">
                        <div
                          onClick={() =>
                            handleOpenFormMainServiceRegister({
                              ...row,
                              patientId,
                            })
                          }
                          style={{
                            display: "inline-block",
                            cursor: "pointer",
                            marginTop: 4,
                          }}
                        >
                          <TouchAppIcon color="primary" fontSize="small" />
                        </div>
                      </Tooltip>
                    )}
                  </div>
                );
              },
            },
            {
              field: "note",
              title: t("Ghi chú"),
              width: "250px",
            },
          ].filter(Boolean)}
          dataPagination={{
            pageIndex: searchAllServices?.pageIndex,
            pageSize: searchAllServices?.pageSize,
            totalElements: pageAllServices?.totalElements,
            totalPages: pageAllServices?.totalPages,
            setPageIndex: (pageIndex) =>
              handleChangeFormSearchService({ pageIndex }),
            setPageSize: (pageSize) =>
              handleChangeFormSearchService({ pageSize }),
          }}
        />
      </Grid>
    </Grid>
  );
};

export default memo(observer(ListAllServices));
